import { SearchInput } from '../../components';
import {
  Breadcrumb,
  EditJobDetailsModal,
  JobSummaryDataTable,
} from './components';
import { useProjectView } from './hooks';
import './ProjectView.scss';

export default function ProjectView() {
  const {
    breadcrumbPath,
    userEmail,
    creationDate,
    creationTime,
    search,
    onChangeSearch,
    jobSummaryList,
    loadingJobSummaries,
    page,
    onChangePage,
    pageSize,
    onChangePageSize,
    count,
    pages,
    onClickEdit,
    editJobDetailsModalOpen,
    editingSummary,
    onCloseModal,
    onModalSave,
  } = useProjectView();

  return (
    <div className='ProjectView'>
      <Breadcrumb
        path={breadcrumbPath}
      />
      <div className='CreatedBy'>
        {`Created by ${userEmail} on ${creationDate} at ${creationTime}`}
      </div>
      <div className='SearchContainer'>
        <div className='TableTitle'>
          Job History
        </div>
        <SearchInput
          value={search}
          onChange={onChangeSearch}
        />
      </div>
      <div className='DataTableContainer'>
        <JobSummaryDataTable
          jobSummaryList={jobSummaryList}
          loadingJobSummaries={loadingJobSummaries}
          page={page}
          onChangePage={onChangePage}
          pageSize={pageSize}
          onChangePageSize={onChangePageSize}
          count={count}
          pages={pages}
          onClickEdit={onClickEdit}
        />
      </div>
      {editJobDetailsModalOpen && (
        <EditJobDetailsModal
          open={editJobDetailsModalOpen}
          onCloseModal={onCloseModal}
          editingSummary={editingSummary}
          onModalSave={onModalSave}
        />
      )}
    </div>
  );
}
